import { computed, ref, watch } from 'vue'
import store from '@/store'

export function useSeguroEntrada(props, emit) {
    const teatro = computed(() => store.getters.getTeatro)

    const selectedFromEntrada = computed(() => {
        if (typeof props.entrada?.seguro_entradas === 'boolean') {
            return props.entrada.seguro_entradas
        }

        if (typeof props.entrada?.seguro === 'boolean') {
            return props.entrada.seguro
        }

        return false
    })

    const selected = ref(false)

    watch(selectedFromEntrada, value => {
        selected.value = value
    }, { immediate: true })

    const titulo = computed(() =>
        props.entrada?.precioSeleccionado?.descripcion ||
        props.entrada?.precio?.descripcion ||
        props.entrada?.descripcion
    )

    const precio = computed(() =>
        props.entrada?.precio?.precio ??
        props.entrada?.precio
    )

    const importeSeguro = computed(() =>
        props.entrada?.importe_seguro_entrada
    )

    const tipoDocumento = computed(() =>
        props.entrada?.tipoDocumentoSeleccionado?.type
    )

    const cartItemId = computed(() =>
        props.entrada?.cart_item_id
    )

    const conSeguro = computed(() => {
        return (
            teatro.value?.seguro_entradas_activo &&
            !window.location.href.includes('packs-eventos') &&
            props.entrada?.importe_seguro_entrada >= teatro.value?.importe_minimo_seguro_entradas &&
            tipoDocumento.value !== 'OTROS' &&
            props.documentacionComprador?.type !== 'OTROS'
        )
    })

    const handleSeguro = seguroSeleccionado => {
        selected.value = seguroSeleccionado

        emit('handleSeguro', {
            cart_item_id: cartItemId.value,
            seguro: seguroSeleccionado,
            importe: props.entrada?.importe_seguro_entrada
        })
    }

    return {
        teatro,
        titulo,
        precio,
        importeSeguro,
        tipoDocumento,
        cartItemId,
        conSeguro,
        selected,
        handleSeguro
    }
}
